var exports = {
  "Vg": "ChatSkeleton.module__grid___NWNhZl",
  "wx": "ChatSkeleton.module__header___NWNhZl",
  "D_": "ChatSkeleton.module__identity___NWNhZl",
  "Ow": "ChatSkeleton.module__identityBack___NWNhZl",
  "um": "ChatSkeleton.module__identityBackDesktop___NWNhZl",
  "W": "ChatSkeleton.module__identityName___NWNhZl",
  "aL": "ChatSkeleton.module__identityCaret___NWNhZl",
  "lf": "ChatSkeleton.module__identityTopicDivider___NWNhZl",
  "$s": "ChatSkeleton.module__headerActions___NWNhZl",
  "QE": "ChatSkeleton.module__headerAction___NWNhZl",
  "YB": "ChatSkeleton.module__headerSearch___NWNhZl",
  "lQ": "ChatSkeleton.module__headerSearchIcon___NWNhZl",
  "Qs": "ChatSkeleton.module__content___NWNhZl",
  "ec": "ChatSkeleton.module__memberListDivider___NWNhZl",
  "oM": "ChatSkeleton.module__chatArea___NWNhZl",
  "JX": "ChatSkeleton.module__chatBody___NWNhZl",
  "DZ": "ChatSkeleton.module__messages___NWNhZl",
  "T_": "ChatSkeleton.module__composerInputLine___NWNhZl",
  "PN": "ChatSkeleton.module__composerAction___NWNhZl",
  "JD": "ChatSkeleton.module__memberList___NWNhZl",
  "Pz": "ChatSkeleton.module__memberListScroller___NWNhZl",
};

module.exports = exports;
